import { createReducer, Action, on } from '@ngrx/store';
import {
    onNgrxForms,
    onNgrxFormsAction,
    SetValueAction,
} from 'ngrx-forms';
import { IReviewState } from './state';
import { DataSavedAction } from './actions';

const defaultState: IReviewState = {
    dataSaved: false,
};

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(DataSavedAction, (_state) => {
        return {
            dataSaved:true
        }
    })
);

export function reviewReducer(state: any | undefined, action: Action) {
    return reducer(state, action);
}
